<template>
  <div class="userInfo">

    <div class="pop">
      <address-book :site_list_show='site_list_show'
                    :recipients='recipients'
                    :addressLibrary='true'></address-book>
      <!-- 忘记密码对话框 -->
      <el-dialog title="重置密码"
                 :visible.sync="reset_password_dialog"
                 width="500px"
                 class="forget_password">
        <el-form>
          <el-form-item label="手机号或邮箱:">
            <el-input v-model="mobile_email"
                      placeholder="请输入手机号或邮箱"></el-input>
          </el-form-item>
          <el-form-item label="验证码:">
            <el-input v-model="mobile_email_code"
                      placeholder="请输入验证码">

              <div class="get_code"
                   slot="suffix">
                <el-button :disabled="btn_display"
                           size="mini"
                           @click="mobile_verification_code(mobile_email)"
                           type="primary">{{data}}{{btn_display?"秒后重试":''}}</el-button>
              </div>
            </el-input>

          </el-form-item>
          <el-form-item label="新密码:">
            <el-input v-model="mobile_email_password"
                      placeholder="请输入新密码"
                      type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码:">
            <el-input v-model="repassword"
                      type="password"
                      placeholder="请再次输入新密码"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="reset_password_dialog = false">取 消</el-button>
          <el-button type="primary"
                     @click="rest_password">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 头像对话框 -->
      <el-dialog title="更改头像"
                 class="change_picture"
                 :visible.sync="avatar_dialog"
                 width="30%">
        <div class="upload_frame ">
          <el-upload class="avatar-uploader"
                     :action="upUrl"
                     :before-upload='beforeAvatarUpload'
                     :show-file-list="false"
                     :limit='1'
                     :headers="headers"
                     ref="upload"
                     :auto-upload='false'
                     :on-change='select_image'
                     name="avatar"
                     :on-success='upload_success'
                     :on-error='upload_erron'
                     accept='image/jpeg/png'
                     :multiple='false'>
            <img v-if="imageUrl"
                 :src="imageUrl"
                 class="avatar">
            <i v-else
               class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>

        <span slot="footer"
              class="dialog-footer">
          <el-button @click="avatar_dialog = false">取 消</el-button>
          <el-button type="primary"
                     @click="to_upload()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 发票对话框 -->
      <el-dialog title="更改发票信息"
                 class="change_picture"
                 :visible.sync="invoice_dialog"
                 width="30%">
        <el-form :model="invoice"
                 ref='invoice'>
          <el-form-item label="抬头名称:"
                        prop="name"
                        :rules="[
      { required: true, message: '公司抬头不能为空'},
    ]">
            <el-input v-model="invoice.name"
                      placeholder="请输入抬头名称"></el-input>
          </el-form-item>
          <el-form-item label="单位税号:"
                        prop="duty_paragraph"
                        :rules="[
      { required: true, message: '单位税号不能为空'},
    ]">
            <el-input v-model="invoice.duty_paragraph"
                      placeholder="请输入单位税号"></el-input>
          </el-form-item>
          <el-form-item label="注册地址:"
                        prop="address"
                        :rules="[
      { required: true, message: '注册地址不能为空'},
    ]">
            <el-input v-model="invoice.address"
                      placeholder="请输入注册地址"></el-input>
          </el-form-item>
          <el-form-item label="注册电话:"
                        prop="mobile"
                        :rules="[
      { required: true, message: '注册电话不能为空'},
    ]">
            <el-input v-model="invoice.mobile"
                      placeholder="请输入注册电话"></el-input>
          </el-form-item>
          <el-form-item label="开户银行:"
                        prop="bank"
                        :rules="[
      { required: true, message: '请输入开户银行'},
    ]">
            <el-input v-model="invoice.bank"
                      placeholder="请输入开户银行"></el-input>
          </el-form-item>
          <el-form-item label="银行账户:"
                        prop="bank_number"
                        :rules="[
      { required: true, message: '请输入开户银行'},
    ]">
            <el-input v-model="invoice.bank_number"
                      placeholder="请输入银行账户"></el-input>
          </el-form-item>
        </el-form>
        <!-- <el-form-item label=""></el-form-item> -->
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="invoice_dialog = false">取 消</el-button>
          <el-button type="primary"
                     @click="change_invoice('invoice')">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 提现信息 -->
      <el-dialog title="提现信息"
                 class="change_Address"
                 width="600px"
                 :visible.sync="withdraw_dialog">
        <div>
          <ul>
            <li>
              <span class="withdraw_title">微信:</span>
              <span>{{wechat_withdraw?'已登记':'未登记'}}</span>
              <el-link type="primary"
                       @click="open_change_withdrawal('wechat')">{{wechat_withdraw?'修改':'登记'}}</el-link>
            </li>
            <li>
              <span class="withdraw_title">支付宝:</span>
              <span>{{alipay_withdraw?'已登记':'未登记'}}</span>
              <el-link type="primary"
                       @click="open_change_withdrawal('alipay')">{{alipay_withdraw?'修改':'登记'}}</el-link>
            </li>
            <li>
              <span class="withdraw_title">银行卡:</span>
              <span>{{card_withdraw?'已登记':'未登记'}}</span>
              <el-link type="primary"
                       @click="open_change_withdrawal('card')">{{card_withdraw?'修改':'登记'}}</el-link>
            </li>
          </ul>
        </div>
        <div>
          <div>
            <span>请选择默认提现方式:</span>
            <br>
            <el-select v-model="defunct_withdraw"
                       placeholder="只能选择登记了的方式">
              <el-option v-for="item in withdraw_data"
                         :key="item.value"
                         :label="item.label"
                         :disabled="item.disabled"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-button style="margin-left:10px"
                       @click="open_change_withdrawal(defunct_withdraw,true)">确 定</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog title="填写提现信息"
                 class='withdrawal_information'
                 :visible.sync="change_withdraw"
                 width="500px">
        <el-form>
          <el-form-item label="请填写微信号:"
                        v-if="active_withdraw=='wechat'">
            <el-input v-model="wechat_withdraw"
                      placeholder="请确定微信号"></el-input>
          </el-form-item>
          <el-form-item label="请填写支付宝号:"
                        v-if="active_withdraw=='alipay'">
            <el-input v-model="alipay_withdraw"
                      placeholder="请确定支付宝号"></el-input>
          </el-form-item>
          <el-form-item label="开户银行名:"
                        v-if="active_withdraw=='card'">
            <el-input v-model="card_withdraw_data.cardbank"
                      placeholder="请填写银行卡开户银行名"></el-input>
          </el-form-item>
          <el-form-item label="开户银行网点:"
                        v-if="active_withdraw=='card'">
            <el-input v-model="card_withdraw_data.bankname"
                      placeholder="请确定银行卡开户银行网点"></el-input>
          </el-form-item>
          <el-form-item label="持卡人姓名:"
                        v-if="active_withdraw=='card'">
            <el-input v-model="card_withdraw_data.username"
                      placeholder="请确定持卡人姓名"></el-input>
          </el-form-item>
          <el-form-item label="持卡人卡号:"
                        v-if="active_withdraw=='card'">
            <el-input v-model="card_withdraw_data.cardno"
                      placeholder="请确定持卡人姓名"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="change_withdraw = false">取 消</el-button>
          <el-button type="primary"
                     @click='change_withdrawal()'>确 定</el-button>
        </span>
      </el-dialog>
      <!-- 电子邮箱对话框 -->
      <el-dialog title="更改电子邮箱"
                 :visible.sync="email_dialog"
                 class="change_email_number"
                 width="30%">

        <div class="used_email">
          <el-form>
            <el-form-item label="旧邮箱号:">
              <span>{{used_email_number}}</span>
            </el-form-item>
            <el-form-item label="验证码:">
              <el-input v-model="used_email_code"
                        placeholder="请输入验证码">
                <div class="get_code"
                     slot="suffix">
                  <el-button type="primary"
                             size="mini"
                             @click="mobile_verification_code(used_email_number)"
                             :disabled="btn_display">{{data}}{{btn_display?"秒后重试":''}}</el-button>
                </div>

              </el-input>

            </el-form-item>
          </el-form>
        </div>

        <span slot="footer"
              class="dialog-footer">
          <el-button @click="email_dialog = false">取 消</el-button>
          <el-button type="primary"
                     @click="used_mobile(used_email_number,used_email_code,true)">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 新邮箱对话框 -->
      <el-dialog title="填写新电子邮箱"
                 :visible.sync="email_dialog_2"
                 class="change_email_number"
                 width="30%">

        <div class="news_email">
          <el-form>
            <el-form-item label="新邮箱号:">
              <el-input v-model="news_email_number"
                        placeholder="请输入新邮箱"></el-input>
            </el-form-item>
            <el-form-item label="验证码:">
              <el-input v-model="news_email_code"
                        placeholder="请输入验证码">
                <div class="get_code"
                     slot="suffix">
                  <el-button type="success"
                             size="mini"
                             @click="mobile_verification_code(news_email_number,true)"
                             :disabled="btn_display_2">{{data_2}}{{btn_display_2?"秒后重试":''}}</el-button>
                </div>
              </el-input>

            </el-form-item>
          </el-form>
        </div>

        <span slot="footer"
              class="dialog-footer">
          <el-button @click="email_dialog_2 = false">取 消</el-button>
          <el-button type="primary"
                     @click="news_email(news_email_number,news_email_code)">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 手机号对话框 -->
      <el-dialog title="更改手机号"
                 :visible.sync="mobile_dialog"
                 key="used_mobile"
                 width="30%"
                 class="change_phone_number">
        <div class="used_mobile">
          <el-form>
            <el-form-item label="请输入旧手机号:">
              <el-input v-model="used_mobile_number"
                        type="number"
                        placeholder="请输入旧手机号"></el-input>

            </el-form-item>
            <el-form-item label="验证码:">
              <el-input v-model="used_mobile_code"
                        placeholder="请输入验证码">

                <div slot="suffix"
                     class="get_code">
                  <el-button type="primary"
                             size='mini'
                             @click="mobile_verification_code(used_mobile_number)"
                             :disabled="btn_display">{{data}}{{btn_display?"秒后重试":''}}</el-button>
                </div>

              </el-input>

            </el-form-item>
          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="mobile_dialog = false">取 消</el-button>
          <el-button type="primary"
                     @click="used_mobile(used_mobile_number,used_mobile_code)">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 新手机对话框 -->
      <el-dialog title="请填写新手机号"
                 :visible.sync="mobile_dialog_2"
                 width="30%"
                 class="change_phone_number">
        <div class="news_mobile">
          <el-form>
            <el-form-item label="请输入新手机号:">
              <el-input v-model="news_mobile_number"
                        placeholder="请输入新手机号"
                        type="number"></el-input>
            </el-form-item>
            <el-form-item label="验证码:">
              <el-input v-model="news_mobile_code"
                        placeholder="请输入验证码">
                <div class="get_code"
                     slot="suffix">
                  <el-button type="success"
                             size="mini"
                             @click="mobile_verification_code(news_mobile_number,true)"
                             :disabled="btn_display_2">{{data_2}}{{btn_display_2?"秒后重试":''}}</el-button>
                </div>
              </el-input>

            </el-form-item>
          </el-form>
        </div>

        <span slot="footer"
              class="dialog-footer">
          <el-button @click="mobile_dialog_2 = false">取 消</el-button>
          <el-button type="primary"
                     @click="news_mobile(news_mobile_number,news_mobile_code)">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <div class="userInfo_left">
      <div class="left_top">
        <div class="top_view">
          <div class="view_top"
               @click="avatar_dialog=true">
            <el-avatar :size="100"
                       :src="headPortrait"></el-avatar>
            <div class="top_info">
              <div class="info_name">{{userInfo}}</div>
              <div class="info_id">ID：{{userId}}</div>
            </div>
          </div>
          <div class="view_bottom">
            <div class="bottom_left">
              <div class="bottom_title">
                余额
              </div>
              <div class="bottom_content">
                {{allmoney}}
              </div>
            </div>
            <div class="bottom_right">
              <div class="bottom_title">
                权限
              </div>
              <div class="bottom_qx">
                {{rolename}}
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="left_bottom">
        <div class="bottom_view">
          <div class="bottom_view_item "
               @click="configuration=1"
               :class="configuration==1?'bottom_view_item_active':''">
            <div class="viewText">
              <i class="el-icon-message"></i>
              <span>信息数据</span>
            </div>
          </div>

          <div class="bottom_view_item"
               @click="configuration=2"
               :class="configuration==2?'bottom_view_item_active':''">
            <div class="viewText">
              <i class="el-icon-takeaway-box"></i>
              <span>地址簿库</span>
            </div>
          </div>

          <!-- <div class="bottom_view_item "
               @click="configuration=3"
               :class="configuration==3?'bottom_view_item_active':''">
            <div class="viewText">
              <i class="el-icon-s-finance"></i>
              <span>我的钱包</span>
            </div>
          </div> -->

        </div>
      </div>
    </div>
    <div class="userInfo_right">
      <div class="userInfo_view"
           v-if="configuration==1">
        <el-form ref="numberValidateForm"
                 label-width="100px"
                 class="demo-ruleForm">
          <div class="userInfo_abs">个人信息</div>

          <el-form-item label="用户名：">
            <el-input v-model="userInfo"
                      size="mini"
                      placeholder="待填写"
                      disabled></el-input>
            <i class="el-icon-s-tools"
               @click="showPop(1)"></i>

          </el-form-item>

          <el-form-item label="绑定手机：">
            <el-input v-model="userMobile"
                      size="mini"
                      placeholder="待绑定"
                      disabled></el-input>
            <i class="el-icon-s-tools"
               @click="showPop(3)"></i>

          </el-form-item>
          <el-form-item label="绑定邮箱：">
            <el-input v-model="userEmail"
                      size="mini"
                      placeholder="待绑定"
                      disabled></el-input>
            <i class="el-icon-s-tools"
               @click="showPop(4)"></i>

          </el-form-item>
          <el-form-item label="绑定微信：">
            <el-input v-model="userWechat"
                      size="mini"
                      placeholder="待绑定"
                      disabled></el-input>
            <i class="el-icon-s-tools"
               @click="showPop(5)"></i>

          </el-form-item>
          <el-form-item label="提现信息：">
            <el-button size="mini"
                       @click="withdraw_dialog=true">点击查看</el-button>
          </el-form-item>
          <el-form-item label="密码重置：">
            <el-button size="mini"
                       @click="reset_password_dialog=true">点击重置</el-button>
          </el-form-item>
        </el-form>

        <el-form ref="numberValidateForm"
                 label-width="100px"
                 class="demo-ruleForm">
          <div class="userInfo_abs">
            <span>发票信息</span>
            <el-link type="primary"
                     @click="invoice_dialog=true">修改</el-link>
          </div>
          <el-form-item label="抬头名称：">
            <el-input v-model="invoice.name"
                      size="mini"
                      placeholder="待填写"
                      disabled></el-input>

          </el-form-item>
          <el-form-item label="单位税号：">
            <el-input v-model="invoice.duty_paragraph"
                      size="mini"
                      placeholder="待绑定"
                      disabled></el-input>
          </el-form-item>
          <el-form-item label="注册电话：">
            <el-input v-model="invoice.mobile"
                      size="mini"
                      placeholder="待绑定"
                      disabled></el-input>
          </el-form-item>
          <el-form-item label="注册地址：">
            <el-input v-model="invoice.address"
                      size="mini"
                      placeholder="待绑定"
                      disabled></el-input>
          </el-form-item>
          <el-form-item label="开户银行：">
            <el-input v-model="invoice.bank"
                      size="mini"
                      placeholder="待绑定"
                      disabled></el-input>
          </el-form-item>
          <el-form-item label="银行账号：">
            <el-input v-model="invoice.bank_number"
                      size="mini"
                      placeholder="待绑定"
                      disabled></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="site_view"
           v-if="configuration==2">
        <el-button type="primary"
                   @click="showAddress(1)">寄件人地址库</el-button>
        <el-button type="success"
                   @click="showAddress(2)">收件人地址库</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import addressBook from '../components/addressBook.vue'
import walletView from '../components/walletView'
import common from '@/assets/js/common'
import { apiUserInfo, apiRestPassword, apiUserData, apiRename, apiMessage, apiUsedMobile, apiWeChat, apiWithdrawal, apiInvoice, apiNewsMobile } from '@/request/api'
export default {
  data () {
    return {
      // --------------更改密码提交信息---------------------------
      //手机或邮箱
      mobile_email: '',
      //手机或邮箱收到的验证码
      mobile_email_code: '',
      //新密码
      mobile_email_password: '',
      repassword: '',
      // --------------更改密码提交信息---------------------------
      used_password: '',
      news_password: '',
      news_password_2: '',
      //登入密码对话框是否显示
      password_dialog: false,
      //忘记对话框是否显示
      reset_password_dialog: false,
      headers: {
        'vue': 1,
        'XTOKIN': this.$store.state.Authorization
      },
      // ----------头像信息-----------
      imageUrl: '',
      // ----------上传的url-----------
      upUrl: this.$store.state.avatarUrl,
      // ----------头像设置对话框是否显示-----------
      avatar_dialog: false,
      // ----------判断是否为寄件地址-----------
      recipients: 1,
      // ----------是否显示地址库数据-----------
      site_list_show: {
        flag: false
      },
      // ------------ 【 发票提交 】 ------------
      invoice: {
        //抬头名称
        name: '',
        //单位税号
        duty_paragraph: '',
        //注册地址
        address: '',
        //注册电话
        mobile: "",
        //开户银行
        bank: '',
        //银行账户
        bank_number: ''
      },
      // ------------ 【 发票是在对话框是否显示 】 ------------
      invoice_dialog: false,
      // ------------ 【 银行卡提现 】 ------------
      card_withdraw_data: {
        //卡户银行
        cardbank: '',
        // 开户网点
        bankname: '',
        //户名
        username: '',
        //卡号
        cardno: ''
      },
      // ------------ 【 填写 】 ------------
      change_withdraw: false,
      // ------------ 【 提现方式 】 ------------
      withdraw_data: [
        {
          label: '微信',
          value: 'wechat',
          disabled: !this.$store.state.userInfo.cash_setting.wechat
        }, {
          label: '支付宝',
          value: 'alipay',
          disabled: !this.$store.state.userInfo.cash_setting.alipay
        }, {
          label: '银行卡',
          value: 'card',
          disabled: !this.$store.state.userInfo.cash_setting.card
        }
      ],
      // ------------ 【 当前提交的提方式 】 ------------
      active_withdraw: '',
      defunct_withdraw: '',
      wechat_withdraw: '',
      alipay_withdraw: '',
      card_withdraw: '',
      // ------------ 【 提现信息 】 ------------
      withdraw_dialog: false,
      // ------------ 【 新邮箱 】 ------------
      news_email_number: '',
      // ------------ 【 新邮箱验证码 】 ------------
      news_email_code: '',
      // ------------ 【 旧邮箱 】 ------------
      used_email_number: this.$store.state.member.email,
      // ------------ 【 旧邮箱验证码 】 ------------
      used_email_code: '',
      // ------------ 【 邮箱对话框是否显示 】 ------------
      email_dialog: false,
      email_dialog_2: false,
      // ------------ 【 倒计时时间 】 ------------
      time_data: 60,
      time_data_2: 60,
      // ------------ 【 倒计时 】 ------------
      data: '获取验证码',
      data_2: '获取验证码',
      // ------------ 【 是否禁用按钮 】 ------------
      btn_display: false,
      btn_display_2: false,
      // ------------ 【 旧手机 】 ------------
      used_mobile_number: '',
      // ------------ 【 旧手机验证码 】 ------------
      used_mobile_code: '',
      // ------------ 【 新手机 】 ------------
      news_mobile_number: '',
      // ------------ 【 新手机验证码 】 ------------
      news_mobile_code: '',
      // ------------ 【 手机对话框是否显示 】 ------------
      mobile_dialog: false,
      mobile_dialog_2: false,
      // ------------ 【 当前显示的配置 】 ------------
      configuration: "1",
      // ------------ 【 用户头像 】 ------------
      headPortrait: "",
      // ------------ 【 用户名 】 ------------
      userInfo: "",
      // ------------ 【 用户id 】 ------------
      userId: "",
      // ------------ 【 用户余额 】 ------------
      allmoney: "",
      // ------------ 【 用户权限 】 ------------
      rolename: '',
      // ------------ 【 用户手机 】 ------------
      userMobile: '',
      // ------------ 【 用户邮箱 】 ------------
      userEmail: '',
      // ------------ 【 用户微信 】 ------------
      userWechat: '',
      // ------------ 【 发票信息 】 ------------
      userInvoice: {},
      // ------------ 【 弹框显示 】 ------------
      pop: {
        username: false
      },
      // ------------ 【 绑定微信对话框是否显示 】 ------------
      wx_dialog: false,

    }
  },
  components: {
    addressBook
  },
  methods: {
    // ----------忘记密码-----------
    async rest_password () {
      let res = await apiRestPassword({
        username: this.mobile_email,
        code: this.mobile_email_code,
        password: this.mobile_email_password,
        repassword: this.repassword
      })
      if (res.errno == 0) {
        this.$message.success(res.message)
        this.reset_password_dialog = false
      } else {
        this.$message.error(res.message)
      }
    },
    // ----------开始上传-----------
    to_upload () {
      if (this.imageUrl == '') {
        return this.$message.error('错误,您还没有选择图片')
      }
      this.$refs.upload.submit();
    },
    // ----------上传失败-----------
    upload_erron () {
    },
    // ----------上传成功-----------
    upload_success (res) {
      if (res.errno === 0) {
        this.$message.success(res.message + ' 请刷新网页')
        this.avatar_dialog = false
        setTimeout(() => {
          // this.$router.go(0)
        }, 1500);
      } else {
        this.$message.error(res.message)
      }
    },
    // ----------选择图片后-----------
    select_image (file, fileList) {
      let url = URL.createObjectURL(file.raw)
      this.imageUrl = url
    },
    // ----------限制用户上传文件类型和大小-----------
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 image | jpeg | png 格式!');
        this.imageUrl = ''
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 1MB!');
        this.imageUrl = ''

      }
      return isJPG && isLt2M;
    },
    // ------------  显示地址库  ------------
    showAddress (type) {
      this.recipients = type
      this.site_list_show.flag = true
    },
    // ------------  确定修改开票信息  ------------
    async change_invoice_click () {
      let res = await apiInvoice({
        fp: this.invoice
      })
      if (res.errno == 0) {
        this.$message.success(res.message)
        this.router.go(0)
      } else {
        this.$message.error(res.message)
      }
    },
    // ------------  更改开票信息  ------------
    change_invoice (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.change_invoice_click()
          this.invoice_dialog = false
        } else {
          return false;
        }
      });
    },
    // ------------更改提现信息------------
    async change_withdrawal () {
      let res = await apiWithdrawal({
        card: this.card_withdraw_data,
        wechat: this.wechat_withdraw,
        alipay: this.alipay_withdraw,
        isselect: this.active_withdraw
      })
      if (res.errno == 0) {
        this.$message.success(res.message)
        setTimeout(() => {
          this.$router.go(0)
        }, 1500);
      } else {
        this.$message.error(res.message)
      }
    },
    // ------------打开提现信息更改界面------------
    open_change_withdrawal (type, flag) {
      if (!flag)
        this.change_withdraw = true
      this.active_withdraw = type
      if (!this.wechat_withdraw) {
        this.wechat_withdraw = ''
      }
      if (!this.alipay_withdraw) {
        this.alipay_withdraw = ''
      }
      if (this.card_withdraw) {
        this.card_withdraw_data = this.$store.state.userInfo.cash_setting.card
      }
      if (flag) {
        this.change_withdrawal()
      }
    },
    // ------------绑定微信------------
    async weChat () {
      let res = await apiWeChat()
      if (res.errno == 0) {
        this.weChat_qr = res.qr
      } else {
        this.$message.error(res.message)
      }
    },
    // ------------打开绑定的微信------------
    openWeChat () {
      this.wx_dialog = true
      this.weChat()
    },
    // ------------验证新手机------------
    async news_mobile (number, code) {
      let res = await apiNewsMobile({
        code: code,
        mobile: number
      })
      if (res.errno == 0) {
        this.$message.success(res.message)
        this.mobile_dialog_2 = false
      } else {
        this.$message.error(res.message)
      }
    },
    // ------------验证新邮箱------------
    async news_email (number, code) {
      let res = await apiNewsMaile({
        code: code,
        email: number
      })
      if (res.errno == 0) {
        this.$message.success(res.message)
        this.email_dialog_2 = false
      } else {
        this.$message.error(res.message)

      }
    },
    // ------------验证旧手机/邮箱------------
    async used_mobile (number, code, flag) {
      let res = await apiUsedMobile({
        code: code,
        receiver: number
      })
      if (res.message.errno == 0) {
        this.news_mobile_entrance(flag)
        this.$message.success(res.message.message)
      } else {
        this.$message.error(res.message.message)
      }
    },
    // ------------倒计时------------
    count_down (flag) {
      if (flag) {
        this.data_2 = this.time_data_2
        this.btn_display_2 = true
      } else {
        this.data = this.time_data
        this.btn_display = true
      }
      let time = setInterval(() => {
        if (flag) {
          this.data_2--
        } else {
          this.data--
        }
        if (flag ? this.data_2 <= 0 : this.data <= 0) {
          if (flag) {
            this.btn_display_2 = false
            this.data_2 = '获取验证码'
          } else {
            this.btn_display = false
            this.data = '获取验证码'
          }
          clearTimeout(time)
        }
      }, 1000);
    },
    // ------------获取验证码------------
    async mobile_verification_code (number, flag) {
      if (number == '') {
        if (flag) {
          return this.$message.error('请输入新手机号')

        }
        return this.$message.error('请输入旧手机号')
      }
      let res = await apiMessage({
        receiver: number,
        codetype: flag ? '' : 1
      })
      if (res.message.errno == 0) {
        this.$message.success(res.message.message)

        this.count_down(flag)
      } else {
        this.$message.error(res.message.message)

      }
    },
    // ------------进入新手机填写界面------------
    news_mobile_entrance (flag) {
      if (flag) {
        this.email_dialog_2 = true
      } else {
        this.mobile_dialog_2 = true
      }
      this.fullscreenLoading = true
      setTimeout(() => {
        if (flag) {
          this.email_dialog = false
        } else {
          this.mobile_dialog = false
        }
        this.data = '获取验证码'
        this.fullscreenLoading = false
      }, 1000);
    },
    // ------------修改用户名------------
    editUserName () {
      this.$prompt('请输入用户名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]{3,15}$/,
        inputErrorMessage: '用户名限制3-15个字符，不可包含非法字符（如空格等符号）'
      }).then(async ({ value }) => {
        let res = await apiRename({
          realname: value
        })
        common.returnData(this, res.errno, res.message, () => {
          this.is_rename = false
          this.$router.go(0)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消修改'
        });
      });
    },
    // ------------关闭弹窗------------
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    // ------------显示弹框------------
    showPop (type) {
      switch (type) {
        case 1:
          this.editUserName()
          break;
        case 3:
          this.mobile_dialog = true
          break;
        case 4:
          this.userEmail
            ? this.email_dialog = true : this.email_dialog_2 = true
          break
        case 5:
          this.openWeChat()
          break;

        default:
          break;
      }
    },
    // ------------获取用户数据------------
    async getUserData () {
      let res = await apiUserData({
        name: ''
      })
      if (res.errno == 0) {
        this.headPortrait = res.userinfo.avatar
        this.imageUrl = res.userinfo.avatar
        this.userInfo = res.userinfo.name
        this.userId = res.userinfo.id
        this.userMobile = res.userinfo.mobile
        this.userEmail = res.member.email
        this.userWechat = res.userinfo.isbang == 1 ? '已绑定' : ''
        this.allmoney = res.allmoney
        this.rolename = res.rolename
        this.used_email_number = res.userinfo.email
        this.wechat_withdraw = res.userinfo.cash_setting.wechat
        this.alipay_withdraw = res.userinfo.cash_setting.alipay
        this.defunct_withdraw = res.userinfo.cash_setting.isselect
        this.card_withdraw = res.userinfo.cash_setting.card
        this.invoice = res.userinfo.fdtablesz || {}
      }
    },
    // 'ck'=>'仓库人员','ckadmin'=>'加盟仓库超级管理','fd'=>'财务管理','sales'=>'业务员',’agent‘=>代理，'kf'=>'客服','driver'=>'司机','admin'=>'系统管理','black'=>'黑名单'

    // ------------获取用户是否完成了配置------------
    async getUserConfig () {
      let res = await apiUserInfo({

      })
      if (res.errno == 0) {

      }
    }
  },
  created () {
    this.$store.commit('setUpUrl')
    this.getUserData()
    this.getUserConfig()
  }
}
</script>

<style lang='scss'>
.userInfo {
  width: 100%;
  height: 100%;
  background-color: #eee;
  display: flex;
  overflow: auto;
  padding: 10px 0;
  padding-right: 10px;
  box-sizing: border-box;
  .change_Address {
    ul {
      // display: flex;
      width: 100%;
      // justify-content: center;
      li {
        font-size: 16px;
        margin-left: 20px;
        width: 100%;
        margin-bottom: 20px;
        display: flex;
        .withdraw_title {
          margin-right: 10px;
          width: 100px;
        }
        .el-link {
          margin-left: 10px;
        }
      }
    }
    .el-form-item__error {
      margin-left: 130px;
    }
    .el-form {
      width: 100%;
      flex-wrap: wrap;
      display: flex;
      .el-form-item {
        .el-form-item__label {
          width: 130px;
        }
        width: 40%;
        margin-left: 20px;
        .el-input {
          width: 60%;
        }
      }
    }
  }
  .change_phone_number,
  .change_password,
  .forget_password,
  .change_picture,
  .change_reconciliation,
  .withdrawal_information,
  .change_email_number {
    .el-form-item__error {
      margin-left: 130px;
    }
    .el-form {
      .el-form-item__label {
        width: 130px;
      }
      .used_mobile_code {
        .get_code {
          display: flex;
          justify-content: flex-end;
        }
        .el-input {
          width: 150px;
        }
      }
      .el-input {
        width: 50%;
      }
    }
  }
  .upload_frame {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
    }
    .avatar-uploader {
      width: 150px;
      height: 150px;
      .el-upload {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  }
  .userInfo_left {
    flex: 1;
    max-width: 300px;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    // padding-top: 50px;
    min-height: 1000px;
    box-sizing: border-box;
    .top_view,
    .bottom_view {
      width: 200px;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
    }
    .left_top {
      width: 100%;
      flex: 1;
      max-height: 300px;
      min-height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      .view_top {
        display: flex;
        align-items: center;
        flex-direction: column;
        .el-avatar {
          cursor: pointer;
          background-color: #fff;
        }
      }
      .view_bottom {
        width: 100%;
        height: 50px;
        background-color: #353636;
        display: flex;
        .bottom_title {
          font-size: 12px;
          color: #fff;
          display: flex;
          justify-content: center;
          margin-top: 4px;
        }
        .bottom_qx,
        .bottom_content {
          display: flex;
          justify-content: center;
          margin-top: 5px;
          font-weight: 700;
          color: #e5d762;
        }
        .bottom_content {
          font-size: 16px;
        }
        .bottom_qx {
          font-size: 14px;
        }
        .bottom_left:hover {
          background-color: #55d2ff86;
        }
        .bottom_left {
          flex: 1;
          background-color: #55d2ff;
          cursor: pointer;
          transition: all 0.3s;
        }
        .bottom_right:hover {
          background-color: #52a0f986;
        }
        .bottom_right {
          flex: 1;
          background-color: #52a0f9;
          cursor: pointer;
          transition: all 0.3s;
        }
      }
      .top_view {
        height: 300px;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;
        background: url("../assets/images/usbgc.png") no-repeat;
        background-color: #fff;
        background-size: 100% 250px;

        .el-avatar {
          margin-top: 20px;
          border: 1px solid #e5d762;
        }
        .top_info {
          .info_name {
            font-size: 18px;
            // font-weight: 700;
            color: #666;
            margin-bottom: 5px;
            margin-top: 10px;
          }
          .info_id {
            display: flex;
            justify-content: center;
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
    .left_bottom {
      overflow: hidden;
      width: 100%;
      flex: 1;
      margin-top: 10px;
      // background-color: rgb(192, 207, 255);
      display: flex;
      justify-content: center;
      align-items: center;
      .bottom_view {
        padding-top: 20px;
        height: 100%;
        box-sizing: border-box;
        .bottom_view_item_active {
          border-left: 3px solid #409eff;
          background-color: #c4e4f7da !important;
          color: #008aff !important;
        }
        .bottom_view_item:hover {
          background-color: #dfeff8a8;
        }
        .bottom_view_item {
          // transition: all 0.3s;
          background-color: #fff;
          cursor: pointer;
          width: 100%;
          height: 50px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          color: #666;
          justify-content: center;
          .viewText {
            display: flex;
            align-items: center;
            i {
              margin-right: 10px;
            }
            span {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .userInfo_right {
    background-color: #fff;
    flex: 1;
    height: 100%;
    border-radius: 10px;
    min-height: 1000px;
    padding: 50px 20px;
    padding-left: 0;
    box-sizing: border-box;
    .userInfo_view {
      width: 100%;
      height: 100%;
      display: flex;
      .userInfo_abs {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        position: absolute;
        left: 30px;
        top: 0;
        color: #999;
      }
      .el-form {
        position: relative;
        margin-bottom: 40px;
        width: 350px;
        padding-right: 100px;
        padding-left: 100px;
        padding-top: 30px;
        .el-form-item__content {
          display: flex;
          align-items: center;
        }
        .el-icon-s-tools:hover {
          color: #409eff;
        }
        .el-icon-s-tools {
          margin-left: 10px;
          color: #999;
          cursor: pointer;
        }
      }

      // background-color: pink;
    }
    .site_view {
      padding-left: 50px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .el-button {
        margin: 0;
        margin-bottom: 20px;
        width: 200px;
      }
    }
  }
}
</style>